import React from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '../content/SiteContext';
import { serviceSchema } from '../lib/schema';
import { PageMeta, PageHero, SectionHead, PackageCard, CtaBand, Icon, Price } from '../components/ui';

const Services = () => {
  const { PACKAGES, ADDONS, SERVICE_PAGES, getPackage } = useSite();
  return (
  <>
    <PageMeta
      title="Car Wash & Detailing at Home | Abu Dhabi & Dubai | Quick Way"
      description="Exterior car wash, interior car cleaning and mobile detailing at your home or office in Abu Dhabi and Dubai. Packages AED 30–65 plus extras."
      path="/services"
      crumbs={[{ name: 'Services', path: '/services' }]}
      jsonLd={[serviceSchema({ name: 'Mobile car wash', description: 'Mobile car wash and detailing at the customer\'s location in Abu Dhabi and Dubai.', path: '/services', offers: PACKAGES })]}
    />
    <PageHero eyebrow="Services" title="Car wash and detailing services at your doorstep">
      <p>From a quick exterior wash to a full detail, every Quick Way service is carried out where your car is parked in Abu Dhabi or Dubai.</p>
    </PageHero>

    <section className="section">
      <div className="container">
        <div className="service-links">
          {SERVICE_PAGES.map((s) => {
            const pkg = getPackage(s.packageId);
            return (
              <Link key={s.slug} to={`/services/${s.slug}`} className="service-link">
                <div>
                  <h2>{s.name}</h2>
                  <p>{s.intro}</p>
                </div>
                <div className="service-link__aside">
                  <span className="muted">{pkg.name}</span>
                  <Price value={pkg.price} />
                  <span className="link-arrow">Details <Icon name="arrow" size={16} /></span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>

    <section className="section section--tint">
      <div className="container">
        <SectionHead eyebrow="Packages" title="Compare what each package includes" />
        <div className="grid grid-3">
          {PACKAGES.map((p) => <PackageCard key={p.id} pkg={p} showExcludes />)}
        </div>
      </div>
    </section>

    <section className="section">
      <div className="container">
        <SectionHead eyebrow="Extras" title="Add-on services">
          Add any of these to a package when you book.
        </SectionHead>
        <div className="grid grid-4">
          {ADDONS.map((a) => (
            <div key={a.id} className="addon">
              <h3>{a.name}</h3>
              <p>{a.desc}</p>
              <Price value={a.price} />
            </div>
          ))}
        </div>
      </div>
    </section>

    <CtaBand source="services" />
  </>
);
};

export default Services;
